import React, { useState } from 'react';

import InputItem from './inputItem';
import { ItemType, OptionType, InputWidgetProps } from './type';

const InputWidget = (props: InputWidgetProps) => {
  const { options, _crengine, onChange, defaultValue, value: pVal } = props;

  const [value, setValue] = useState<OptionType>(pVal || defaultValue || []);

  const onComponentChange = (item:ItemType) => {
    let isExiteIndex = -1;

    if (value && Array.isArray(value)) {
      if (value.length === 0) {
        value.push(item);
      } else {
        value.forEach((val, index) => {
          if (val.name === item.name) {
            isExiteIndex = index;
          }
        });

        if (isExiteIndex === -1) {
          value.push(item);
        } else {
          value.splice(isExiteIndex, 1, item);
        }
      }

      setValue(value);
      onChange(value);
    }
  };

  const bindData = (item) => {
    const { value: bVal, defaultValue: bDefauleValue } = props;
    if (bVal && Array.isArray(bVal) && bVal.length) {
      bVal.forEach((bItem) => {
        if (bItem.name === (item.name || item.dataBind)) {
          item.defaultValue = bItem.value;
        }
      });
    } else if (bDefauleValue && Array.isArray(bDefauleValue) && bDefauleValue.length) {
      bDefauleValue.forEach((bItem) => {
        if (bItem.name === (item.name || item.dataBind)) {
          item.defaultValue = bItem.value;
        }
      });
    }
    return item;
  };

  return (
    <>
      {
        options && Array.isArray(options) && options.length > 0 && options.map((item, index) => {
          const lItem = bindData(item);
          return (
            <InputItem
              {...lItem}
              _crengine={_crengine}
              key={index}
              onChange={(data) => onComponentChange(data)}
            />
          );
        })
      }
    </>
  );
};

export default InputWidget;
